import { render } from "./AccountantEdit.vue?vue&type=template&id=0603c5d0&scoped=true"
import script from "./AccountantEdit.vue?vue&type=script&lang=js"
export * from "./AccountantEdit.vue?vue&type=script&lang=js"

import "./AccountantEdit.vue?vue&type=style&index=0&id=0603c5d0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0603c5d0"]])

export default __exports__